import React from 'react'

import { ExperienceTabContent } from '../components/certificateTabs/tabs/ExperienceTabContent'
import { CertificateSubView } from './CertificateSubView'

/**
 * VRG-782 — the brand's Experience copy, as its own screen, for the OWNER.
 *
 * ## Why only the owner reaches this route, when the content is not private
 *
 * `CertificateSubView` redirects anyone who is not the certificate's owner, which is
 * right for Provenance / Scans / Activity (a stranger has no business in the owner's
 * log) and looks wrong here — Experience is brand marketing copy, the least private
 * thing on the record.
 *
 * It is not a gate on the content. A public visitor DOES see this copy; they see it
 * INLINE, in the public certificate's vertical stack, next to `ProductTabContent`.
 * That is the public certificate's own documented shape — `PublicCertificateSections`
 * states it: a visitor arrives by tapping a tag with one question, so everything
 * published is on one scroll "rather than behind tabs they have no reason to know
 * about". A row they must discover and tap is exactly the affordance that note rejects.
 *
 * So the two audiences get the same component in the layout each of them already has:
 * the owner's record is a list of rows that push, the visitor's is one scroll. Nothing
 * is withheld, and neither layout gets a foreign idiom bolted onto it.
 */
export const ExperienceSubView = () => (
  <CertificateSubView title='Experience'>
    {certificate => <ExperienceTabContent content={certificate?.product?.experience_content} />}
  </CertificateSubView>
)
